export const shopifyUrl = {
  SHOPIFY_BLOG_ARTICLES:          "SHOPIFY_BLOG_ARTICLES",
}